import type { RequestOptions } from '@@/plugin-request/request';
import { request as umiRequest } from '@umijs/max';
import { BizAppConfig } from 'config/application.manifest';

type ScopedRequestOptions = RequestOptions;

export function createRequest(baseURL?: string) {
  return <T = unknown>(url: string, options?: ScopedRequestOptions) => {
    const scopedBaseURL = baseURL ?? BizAppConfig?.appApiUrl ?? '';
    return (
      umiRequest as unknown as <R = unknown>(
        requestUrl: string,
        requestOptions?: ScopedRequestOptions,
      ) => Promise<R>
    )<T>(url, {
      baseURL: scopedBaseURL,
      ...(options || {}),
    });
  };
}

export function createAppRequest() {
  return <T = unknown>(url: string, options?: ScopedRequestOptions) => {
    const scopedBaseURL = BizAppConfig?.appApiUrl ?? '';
    return createRequest(scopedBaseURL)<T>(url, options);
  };
}

export function createTenantManagementRequest() {
  return <T = unknown>(url: string, options?: ScopedRequestOptions) => {
    const scopedBaseURL = BizAppConfig?.appTenantManagementUrl ?? '';
    return createRequest(scopedBaseURL)<T>(url, options);
  };
}
